import { defineComponent, h } from "vue";
import BelowTheFold from "../../components/BelowTheFold/BelowTheFold.mjs";
import "core-js/modules/es.array.push.js";
import { TOGGLE_ACCORDION_SECTION, ADD_MEMBERSHIP_TO_CART, HANDLE_PRERENDER, METRICS_CLICK, OPEN_MODAL, HANDLE_RECS_CLICK, TOGGLE_ACCORDION_VISIBILITY, INIT_GLADLY_CHAT, OPEN_GLADLY_CHAT } from "../../store/constants.mjs";
import "bezier-easing";
import "js-cookie";
import "core-js/modules/esnext.set.difference.v2.js";
import "core-js/modules/esnext.set.intersection.v2.js";
import "core-js/modules/esnext.set.is-disjoint-from.v2.js";
import "core-js/modules/esnext.set.is-subset-of.v2.js";
import "core-js/modules/esnext.set.is-superset-of.v2.js";
import "core-js/modules/esnext.set.symmetric-difference.v2.js";
import "core-js/modules/esnext.set.union.v2.js";
import "@rei/cedar";
import "@rei/spinner";
import "@rei/cdr-tokens";
/* empty css                                                              */
/* empty css                                          */
import "../../components/MediaCenter/MediaCenterHeroImage/MediaCenterHeroImage.mjs";
/* empty css                                                                       */
/* empty css                                  */
/* empty css                                                            */
import "@rei/session";
import useProductReviewsStore from "../../stores/productReviewsStore.mjs";
const BelowTheFoldContainer = defineComponent({
  name: "BelowTheFoldContainer",
  render() {
    const {
      getters,
      dispatch,
      commit
    } = this.$store;
    const { showNativeReviews } = getters;
    const productReviewsStore = showNativeReviews ? useProductReviewsStore() : {
      productReviewsProps: null,
      handleUserStarClick: () => {
      },
      handleFilterByStarRating: () => {
      },
      handleIndividualReviewFeedback: () => {
      },
      handleReviewsSort: () => {
      },
      handlePagination: () => {
      }
    };
    return h(BelowTheFold, {
      ...getters.belowTheFoldProps,
      productReviewsProps: productReviewsStore.productReviewsProps,
      onAccordionToggle: (id) => commit(TOGGLE_ACCORDION_SECTION, id),
      onAddMembershipToCart: (data) => dispatch(ADD_MEMBERSHIP_TO_CART, data),
      onBvContainerMounted: (bvRef) => dispatch(HANDLE_PRERENDER, bvRef),
      onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
      onModalOpen: (data) => dispatch(OPEN_MODAL, data),
      onRecsClick: (data) => dispatch(HANDLE_RECS_CLICK, { data }),
      onSetAccordionVisible: (status) => commit(TOGGLE_ACCORDION_VISIBILITY, status),
      onInitGladlyChat: () => dispatch(INIT_GLADLY_CHAT),
      onCallGladlyChat: () => dispatch(OPEN_GLADLY_CHAT),
      onReviewStarClick: (rating) => productReviewsStore.handleUserStarClick(rating),
      onProductRatingFilterClick: (rating) => productReviewsStore.handleFilterByStarRating({ [rating]: true }),
      onIndividualReviewFeedbackClick: (payload) => {
        productReviewsStore.handleIndividualReviewFeedback(payload);
      },
      onProductReviewsSort: (payload) => {
        productReviewsStore.handleReviewsSort(payload);
      },
      onProductReviewsStarsChanged: (payload) => {
        productReviewsStore.handleFilterByStarRating(payload);
      },
      onProductReviewsPagination: (payload) => {
        productReviewsStore.handlePagination(payload);
      }
    });
  }
});
export {
  BelowTheFoldContainer as default
};
//# sourceMappingURL=BelowTheFoldContainer.mjs.map
